export default (): FlyoutMenuComponent => {
    return {
        isOpen: false,
        //     handleBlurBox(away: boolean) {
        //         const blurBox: any = document.querySelector(".om-menu-blur");
        //         if (away) {
        //             this.isOpen = false;
        //             if (blurBox) {
        //                 blurBox.style.height = 0;
        //                 if (!blurBox.classList.contains("hidden")) {
        //                     blurBox.classList.add("hidden");
        //                 }
        //             }
        //         } else {
        //             this.isOpen = !this.isOpen;
        //             setTimeout(() => {
        //                 if (blurBox) {
        //                     blurBox.style.height =
        //                         this.$refs.flyout.clientHeight + "px";
        //                     if (
        //                         blurBox.style.height !== "0px" &&
        //                         blurBox.classList.contains("hidden")
        //                     )
        //                         blurBox.classList.remove("hidden");
        //                 }
        //             }, 100);
        //         }
        //     },
    };
};

import { AlpineComponent } from "alpinejs";

type FlyoutMenuComponent = AlpineComponent<{
    isOpen: boolean;
    // handleBlurBox: Function;
}>;
